import React from 'react';
import { makeStyles } from 'tss-react/mui';
const useStyles = makeStyles()(theme => {
    return {
        addWhiteboard: {
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            "&:hover": {
                scale: '1.025'
            }
        }
    };
});
const IconAddWhiteboard = () => {
    const { cx, classes } = useStyles();
    return (React.createElement("svg", { className: cx(classes.addWhiteboard), width: "85", height: "85", viewBox: "0 0 85 85", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("g", { clipPath: "url(#clip0_2911_4206)" },
            React.createElement("path", { d: "M22.6667 2.8335H8.50004C6.99715 2.8335 5.55581 3.43052 4.4931 4.49322C3.4304 5.55593 2.83337 6.99727 2.83337 8.50016V22.6668M34 2.8335H51M62.3334 2.8335H76.5C78.0029 2.8335 79.4443 3.43052 80.507 4.49322C81.5697 5.55593 82.1667 6.99727 82.1667 8.50016V22.6668M2.83337 34.0002V51.0002M82.1667 34.0002V51.0002M2.83337 62.3335V76.5002C2.83337 78.0031 3.4304 79.4444 4.4931 80.5071C5.55581 81.5698 6.99715 82.1668 8.50004 82.1668H22.6667M82.1667 62.3335V76.5002C82.1667 78.0031 81.5697 79.4444 80.507 80.5071C79.4443 81.5698 78.0029 82.1668 76.5 82.1668H62.3334M42.5 22.6668V62.3335M22.6667 42.5002H62.3334M34 82.1668H51", stroke: "#EE0033", strokeOpacity: "0.7", strokeWidth: "4" })),
        React.createElement("defs", null,
            React.createElement("clipPath", { id: "clip0_2911_4206" },
                React.createElement("rect", { width: "85", height: "85", fill: "white" })))));
};
export default IconAddWhiteboard;
